// extracted by mini-css-extract-plugin
module.exports = {"form_inputs":"DlComp-module--form_inputs--2r_KU"};